import './MainComponent.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import i18n from '../i18n';


export default function MainComponent() {
    const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
    
    const navigate = useNavigate();

    function handleAccountEnter() {
        window.open(`/login`, '_blank', 'noopener,noreferrer');
    }

    const { t } = useTranslation();
    
    return(
        <section className='main-section'>
            <div className='main-text'>
                <h1 className='title'>
                    <Trans
                        i18nKey="$Header1"
                        components={{ highlight: <span className="title-colored" /> }}
                    />                
                </h1>
                <p className='descr'>
                    {t('$Subheader1')}
                </p>
            </div>
            <div className='main-bttns'>
                <button id='materials' onClick={handleAccountEnter}>
                    {t('$Buttom1')}
                </button>
                <button id='product'>
                    <a href='#video-section'>
                    {t('$Buttom2')}
                    </a>
                </button>
            </div>
        </section>
    );
}